import { Nilable } from "@shared/utils";
import { AccionEnum } from "@shared/enums";

export enum EstadoEnum { CORRECTO, ERROR, REPETIDO }

export interface EstadoAccion<T> {
    accion: AccionEnum;
    estado: EstadoEnum;
    entidad?: Nilable<T>;
}
